const apiEndPOints = {
	LOGIN_START: "/auth",
	LOGIN_REFRESH_TOKEN: "/auth/token",
	LOGIN_VERIFY_OTP: "/auth/validate",

	GET_LOCATION_DETAILS_KEY: "/location/info",

	GET_LOCATION_DETAILS: "/location/v1/info",

	GET_S3_BUCKET_DETAILS: "/order/bucketinfo",

	QUOTE_ORDER: "/order/quoteOrder",

	COMPLETE_ORDER: "/order/ordercompletion",

	UPDATE_ORDER_ITEMS: "/order/placeOrder",

	GET_INFORMATION_ZIP: "/location/getinfofromzip",

	ERROR_LOG_ENDPOINT: "/order/logs",
};

export default apiEndPOints;
